import AutomateCalcsPng from '@public/images/fintech-and-banking/automate-calcs.png'

import { BlogPreview } from '@/components/blogSlices/BlogPreview'
import { ColumnWrapOrder } from '@/components/TwoColumnLayout'
import TwoColumnLayoutWithCustomImageRatio from '@/components/TwoColumnLayoutWithCustomImageRatio'

const EmissionCalculationsFintech = () => (
    <TwoColumnLayoutWithCustomImageRatio
        columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
        image={AutomateCalcsPng}
        imageAlt={`Emission calculations`}
        imagePaddingBottom={'122.45%'}
        title={`Spend- or activity-based calculations for each item`}
        snippet={
            <BlogPreview
                title={
                    "Spend vs activity-based: What's the best methodology for calculating carbon emissions?"
                }
                url={'/blog/best-methodology-for-calculating-carbon-emissions'}
            />
        }
        description={
            <>
                {`Streamline your customers' ESG reporting with Lune's granular spend- and activity-based emission calculations. Covering tens of thousands product categories and materials, Lune uses AI to match product data with emissions data.`}
            </>
        }
    />
)

export default EmissionCalculationsFintech
